import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ConfiguracoesWhatsAppResponse,
  AtualizarChamadoPorAtendenteRequest,
  AtualizarChamadoPorAtendenteResponse
} from '../models/configuracoes-whatsapp.model';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracoesWhatsAppService {
  private baseUrl = `${environment.apiUrl}/v1/ConfiguracoesWhatsApp`;

  constructor(private http: HttpClient) {}

  /**
   * Obter configurações do WhatsApp
   * GET /api/v1/ConfiguracoesWhatsApp
   */
  obterConfiguracoes(): Observable<ConfiguracoesWhatsAppResponse> {
    const headers = this.getAuthHeaders();
    
    return this.http.get<ConfiguracoesWhatsAppResponse>(
      this.baseUrl,
      { headers }
    );
  }

  /**
   * Atualizar quantidade de chamados por atendente
   * PUT /api/v1/ConfiguracoesWhatsApp/chamado-por-atendente
   */
  atualizarChamadoPorAtendente(
    quantidadeChamadoPorAtendente: number
  ): Observable<AtualizarChamadoPorAtendenteResponse> {
    const headers = this.getAuthHeaders();
    const body: AtualizarChamadoPorAtendenteRequest = {
      quantidadeChamadoPorAtendente
    };
    
    return this.http.put<AtualizarChamadoPorAtendenteResponse>(
      `${this.baseUrl}/chamado-por-atendente`,
      body,
      { headers }
    );
  }

  /**
   * Obter headers de autenticação com JWT Bearer Token
   */
  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('jwt_token');
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  }
}
